import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VLayout,{attrs:{"align-center":""}},[_c('span',{staticClass:"ag-grid-clickable-cell"},[_vm._v(_vm._s(_vm.params.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }